import { adSpaceAccepted, campaignPaused, campaignReactivated, newCampaignStarted } from './notifications';

import { AccountService } from '../services/account.service';
import { AdSpaceService } from '../services/ad-space.service';
import { OfferService } from '../services/offer.service';

export interface IAdSpace {
  id?: number;
  account: number;
  account_info: {
    primary_user_id?: number;
  };
  name: string;
  url: string;
  description: string;
  traffic: number;
  traffic_info: any;
  categories: number[];
  categories_info: any[];
  verticals: number[];
  verticals_info: any[];
  reach: number[];
  logo?: string;
}

export const userStatusOptions = [
  { id: true, name: 'Active' },
  { id: false, name: 'Inactive' },
];

export const userStatusFilterOptions = [
  { id: '', name: 'All' },
  { id: true, name: 'Active' },
  { id: false, name: 'Inactive' },
];

export const adSpaceStatusFilterOptions = [
  { id: 'Accepted', name: 'Accepted' },
  { id: 'Pending', name: 'Pending' },
  { id: 'Rejected', name: 'Rejected' },
];

export const accountTypeFilterOptions = [
  { id: '', name: 'All' },
  { id: 'publisher', name: 'Publisher' },
  { id: 'advertiser', name: 'Advertiser' },
];

export const adSpaceNotificationOptions = [
  newCampaignStarted,
  adSpaceAccepted,
  campaignPaused,
  campaignReactivated,
];

export const dropdownSettings: object = {
  singleSelection: false,
  lazyLoading: true,
  selectAllText: 'Select All',
  unSelectAllText: 'UnSelect All',
  enableSearchFilter: true,
  classes: 'myclass custom-class',
  labelKey: 'name',
};

export const AdSpaceApplicationStatus = {
  ACCEPTED: 'Accepted',
  REJECTED: 'Rejected',
  PENDING: 'Pending',
};

export const adSpaceStatusOptions = [
  { id: 'Active', name: 'Active' },
  { id: 'Inactive', name: 'Inactive' },
  { id: 'Pending', name: 'Pending' },
];

export interface OfferAdSpaceFilters {
  status_filter: any;
  adspace_filter: any;
  traffic_filter: any;
  vertical_filter: any;
  category_filter: any;
  commission_model_filter: any;
  reach_filter: any;
}

export interface AdSpaceFilter {
  name: string;
  param: string; // Backend filter query param name
  optionProvider: ((self: AdSpaceList) => Promise<any>) | false;
  options: Promise<any[]> | null;
  selected: string;
  active: boolean;
}

export interface AdSpaceList {
  accountService: AccountService;
  adSpaceService: AdSpaceService;
  offerService: OfferService;
}

export const advertiserAdSpaceFilters: AdSpaceFilter[] = [
  {
    name: 'Status',
    param: 'status',
    optionProvider: false,
    options: Promise.resolve(adSpaceStatusFilterOptions),
    selected: '',
    active: false,
  },
  {
    name: 'AdSpace',
    param: 'media',
    optionProvider: (self) =>
      self.offerService.getAdSpaceMediaMapping().toPromise()
        .then((response: any[]) =>
          response.map((x) => x.media_info)),
    options: null,
    selected: '',
    active: false,
  },
  {
    name: 'Offer',
    param: 'offers',
    optionProvider: (self) =>
      self.offerService.getLeanOfferList().toPromise(),
    options: null,
    selected: '',
    active: false,
  },
];

export const adminAdSpaceFilters: AdSpaceFilter[] = [
  {
    name: 'Status',
    param: 'status',
    optionProvider: false,
    options: Promise.resolve(adSpaceStatusOptions),
    selected: '',
    active: false,
  },
  {
    name: 'Publisher',
    param: 'publishers',
    optionProvider: (self) => self.accountService.getAllPublisherAccounts(),
    options: null,
    selected: '',
    active: false,
  },
  {
    name: 'Traffic',
    param: 'traffic',
    optionProvider: (self) => self.adSpaceService.getAdspaceTraffic(),
    options: null,
    selected: '',
    active: false,
  },
  {
    name: 'Vertical',
    param: 'verticals',
    optionProvider: (self) => self.adSpaceService.getAdspaceVertical(),
    options: null,
    selected: '',
    active: false,
  },
  {
    name: 'Category',
    param: 'categories',
    optionProvider: (self) => self.adSpaceService.getAdspaceCategory(),
    options: null,
    selected: '',
    active: false,
  },
];
